import api from '.'
import { InternalCategoriesReq } from './internalCategories.types'

export const InternalCategoriesKey = {
	all: ['internalCategories'],
	list: (query: InternalCategoriesReq) => [...InternalCategoriesKey.all, query], // { input, page, pageSize },
}

const InternalCategoriesApi = {
	list: (query: InternalCategoriesReq) =>
		api
			.get<PaginatedAPIRes<CategorySearchResult[]>>(`/internal-categories`, { params: query })
			.then((res) => res.data),
}

export default InternalCategoriesApi
